import { render, staticRenderFns } from "./k-flip-select.vue?vue&type=template&id=20cc86e6&scoped=true"
import script from "./k-flip-select.vue?vue&type=script&lang=js"
export * from "./k-flip-select.vue?vue&type=script&lang=js"
import style0 from "./k-flip-select.vue?vue&type=style&index=0&id=20cc86e6&prod&lang=scss&scoped=true"
import style1 from "./k-flip-select.vue?vue&type=style&index=1&id=20cc86e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc86e6",
  null
  
)

export default component.exports